import { Spinner } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import ScientistError from 'common/illustrations/ScientistError';
import { Typography as T } from 'common/typography';

const StyledSpinner = styled(Spinner)`
  flex: 1 1 auto;
  margin: 0 auto;
`;

const Error = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 32px;
  margin-block-end: 20%;
`;

const StyledScientistError = styled(ScientistError)`
  width: 100%;
  max-width: 375px;
  margin-block-end: 32px;
`;

const ErrorHeading = styled(T.Heading3)`
  max-width: 476px;
  margin-block-end: 16px;
`;

const ErrorBody = styled(T.Body2)`
  max-width: 476px;
`;
export type LookerDashboardViewProps = {
  isLoading: boolean;
  hasFetchDashboardError: boolean;
  hasLoadDashboardInIframeError: boolean;
  children: React.ReactNode;
};

export const LookerDashboardView = ({
  isLoading,
  hasFetchDashboardError,
  hasLoadDashboardInIframeError,
  children,
}: LookerDashboardViewProps) => {
  if (isLoading) {
    return <StyledSpinner size="medium" />;
  }
  if (hasFetchDashboardError || hasLoadDashboardInIframeError) {
    return (
      <Error>
        <StyledScientistError />
        <ErrorHeading>
          <FormattedMessage id="looker-analytics.error-heading" />
        </ErrorHeading>
        <ErrorBody>
          <FormattedMessage id="looker-analytics.error-body" />
        </ErrorBody>
      </Error>
    );
  }
  return <>{children}</>;
};
